module.exports = __webpack_public_path__ + "static/media/vividseats.d8df3123.png";